<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Standard Comm/Disc Factors</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <cal-picker :label="'Standard Comm/Disc Factors as at'" v-model="effDate" @input="fetchStandardCommDiscFactors()"></cal-picker>
      </v-flex>
      <v-flex xs6></v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="product" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ formatDateTime2(props.item.effDate) }}</td>
        <td class="text-xs-left">{{ formatDateTime2(props.item.endDate) }}</td>
        <td class="text-xs-left">{{ props.item.fact1 }}</td>
        <td class="text-xs-left">{{ props.item.fact2 }}</td>
        <td class="text-xs-left">{{ props.item.fact3 }}</td>
        <td class="text-xs-left">{{ props.item.fact4 }}</td>
        <td class="text-xs-left">{{ props.item.fact5 }}</td>
        <td class="text-xs-left">{{ props.item.fact6 }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review remove @review="doReview(props.item)" @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Add Standard Comm/Disc Factor
        <v-icon right>mdi-table-row-plus-before</v-icon>
      </v-btn>
    </v-card-text>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Standard Comm/Disc Factor?
      <div class="title">{{deleteStdCommDiscFact}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { PRODUCT_STDCOMMDISCFACT, PRODUCT_STDCOMMDISCFACT_TABMENU } from '@/store/types'
import { formatDisplayDateTime2 } from '@/utils/date'
import { appID } from '@/const/underwriting'

export default {
  data() {
    return {
      headers: [
        { text: 'Effective Date', align: 'left', value: 'effDate', sortable: false },
        { text: 'End Date', align: 'left', value: 'endDate', sortable: false },
        { text: 'Factor 1', align: 'left', value: 'fact1', sortable: false },
        { text: 'Factor 2', align: 'left', value: 'fact2', sortable: false },
        { text: 'Factor 3', align: 'left', value: 'fact3', sortable: false },
        { text: 'Factor 4', align: 'left', value: 'fact4', sortable: false },
        { text: 'Factor 5', align: 'left', value: 'fact5', sortable: false },
        { text: 'Factor 6', align: 'left', value: 'fact6', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedStdCommDiscFact: undefined,
      deleteStdCommDiscFact: '',
      effDate: undefined
    }
  },
  computed: {
    productAppID() {
      return this.$store.state.productManagement.product.appID
    }
  },
  methods: {
    async doInit() {
      const commitData = {
        stdCommDiscFactTab: 0,
        displayRateTab: false,
        product: undefined,
        effDate: undefined
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      await this.fetchStandardCommDiscFactors()
    },
    doReview(data) {
      const stdCommDiscFactors = {
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      const commitData = {
        stdCommDiscFactTab: 1,
        displayFactReviewTab: true,
        effDate: data.effDate
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT, stdCommDiscFactors)
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      if (this.productAppID === appID.MOTOR) {
        this.$router.push({ name: 'motorStdCommDiscFactorReview', params: { effectiveDate: data.effDate } })
      } else if (this.productAppID === appID.TRAVEL) {
        this.$router.push({ name: 'travelStdCommDiscFactorReview', params: { effectiveDate: data.effDate } })
      } else if (this.productAppID === appID.FIRE) {
        this.$router.push({ name: 'fireStdCommDiscFactorReview', params: { effectiveDate: data.effDate } })
      } else if (this.productAppID === appID.CARGO) {
        this.$router.push({ name: 'cargoStdCommDiscFactorReview', params: { effectiveDate: data.effDate } })
      } else if (this.productAppID === appID.MAID) {
        this.$router.push({ name: 'maidStdCommDiscFactorReview', params: { effectiveDate: data.effDate } })
      } else if (this.productAppID === appID.PACKAGE) {
        this.$router.push({ name: 'packageStdCommDiscFactorReview', params: { effectiveDate: data.effDate } })
      }
    },
    doNew() {
      const commitData = {
        stdCommDiscFactTab: 1,
        displayFactReviewTab: true
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      if (this.productAppID === appID.MOTOR) {
        this.$router.push({ name: 'motorStdCommDiscFactorReview', params: { effectiveDate: 'New' } })
      } else if (this.productAppID === appID.TRAVEL) {
        this.$router.push({ name: 'travelStdCommDiscFactorReview', params: { effectiveDate: 'New' } })
      } else if (this.productAppID === appID.FIRE) {
        this.$router.push({ name: 'fireStdCommDiscFactorReview', params: { effectiveDate: 'New' } })
      } else if (this.productAppID === appID.CARGO) {
        this.$router.push({ name: 'cargoStdCommDiscFactorReview', params: { effectiveDate: 'New' } })
      } else if (this.productAppID === appID.MAID) {
        this.$router.push({ name: 'maidStdCommDiscFactorReview', params: { effectiveDate: 'New' } })
      } else if (this.productAppID === appID.PACKAGE) {
        this.$router.push({ name: 'packageStdCommDiscFactorReview', params: { effectiveDate: 'New' } })
      }
    },
    async fetchStandardCommDiscFactors() {
      const apiURI = this.$store.state.productManagement.product.menu.stdCommDiscFactors
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            product: this.product,
            effDate: formatDisplayDateTime2(this.effDate)
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((stdCommDiscFactor) => {
                const convertStdCommDiscFactor = {
                  effDate: stdCommDiscFactor.effDate,
                  endDate: stdCommDiscFactor.endDate,
                  fact1: this.formatFact(stdCommDiscFactor.fact1),
                  fact2: this.formatFact(stdCommDiscFactor.fact2),
                  fact3: this.formatFact(stdCommDiscFactor.fact3),
                  fact4: this.formatFact(stdCommDiscFactor.fact4),
                  fact5: this.formatFact(stdCommDiscFactor.fact5),
                  fact6: this.formatFact(stdCommDiscFactor.fact6),
                  revision: stdCommDiscFactor.revision
                }
                this.items.push(convertStdCommDiscFactor)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedStdCommDiscFact = data
        this.deleteStdCommDiscFact = data.fact1 + ' / ' + data.fact2 + ' / ' + data.fact3 + ' / ' + data.fact4 + ' / ' + data.fact5 + ' / ' + data.fact6
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.productManagement.product.menu.stdCommDiscFactorDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          product: this.product,
          effDate: this.selectedStdCommDiscFact.effDate
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchStandardCommDiscFactors()
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatFact(fact) {
      if (fact && fact !== null) {
        return fact
      } else {
        return '-'
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  created() {
    this.effDate = new Date()
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
